<h2 mat-dialog-title>Current Stock</h2>

<mat-dialog-content class="mat-typography">
  <app-grocy-current-stock />
</mat-dialog-content>
